import type { Module } from 'vuex'
import type { RootState } from '@/store'
import type { DevicesState, SetDevicePayload } from './types'
import { DEVICE_ACTIONS, DEVICE_GETTERS } from './types'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

const devices: Module<DevicesState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export { DEVICE_ACTIONS, DEVICE_GETTERS }
export type { DevicesState, SetDevicePayload }
export default devices
